import { assert } from '@varos/util-typescript';
import { ChatItemCreateAggregate } from './chatCreateModel';
import { ReportingShellLoaderBaseConfig } from '../../../../base';
import { ChatItemCreateLoader } from './chatCreateInterface';

export function createChatItemCreateLoader(
    config: ReportingShellLoaderBaseConfig
): ChatItemCreateLoader {
    const {
        repository: { research: repository },
    } = config;
    return {
        useLoad(context, props): ChatItemCreateAggregate {
            const contentQuery = repository.content.useLookupMaybe(
                context,
                props.item.result.document.id,
                {
                    suspense: true,
                }
            );
            assert(contentQuery.status === 'success', 'expected suspense');
            return {
                tool: props.item.tool,
                result: props.item.result,
                content: contentQuery.data,
            };
        },
    };
}
